import { Link } from "react-router-dom";
import data from "../../data"
import { ResumeBasicInfo } from "./resumeBasicInfo";
import { ResumeEducation } from "./resumeEducation";
import { ResumeExperience } from "./resumeExperience";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Resume() { 
    const currentYear = new Date().getFullYear();
    const resumeInfo = data.resume.info

    const resumeBasicInfo = resumeInfo.about.map((item, index) => (
        <ResumeBasicInfo key={index} {...item} />
    ));

    const resumeSkills = resumeInfo.skills.map((item, index) => (
        <div className="skill-content">
            <h4>{item.title}:</h4>
            <ul key={index}>
            {item.skill_list.map((skill, subIndex) => (
                <li key={subIndex}>{skill}</li>
            ))}
            </ul>
        </div>
    ));

    const resumeEducation = resumeInfo.education.map((item, index) => (
        <ResumeEducation key={index} {...item} />
    ))
    
    const resumeExperience = resumeInfo.experience.map((item, index) => (
        <ResumeExperience key={index} {...item} />
    ))

    return (
        <section className="resume" animateIn="animate__fadeIn">
            <div className="return">
                <Link to="/">
                    <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
                    <i>back to profile</i>
                </Link>
          
                <a href={resumeInfo.cv} download={resumeInfo.cv} rel="noreferrer">
                    Download Resume
                </a>
            </div>
            
            <section className="resume_content">
                <div className="resume_content-title">
                    <h2>{resumeInfo.name}</h2>
                    <h3>{resumeInfo.position}</h3>
                </div>

                <div className="resume_content-container">
                    <section className="resume_content-info">
                        <article className="about">
                            {resumeBasicInfo}
                        </article>

                        <article className="skills">
                            <h3>Skills</h3>
                            {resumeSkills}
                        </article>

                        <article className="education">
                            <h3>Education</h3>
                            {resumeEducation}
                        </article>
                    </section>

                    <section className="resume_content-info">
                        <h3>Work experience</h3>
                        {resumeExperience}
                    </section>
                </div>
            </section>

            <div className="footer">
                © Copyright {currentYear}
            </div>
        </section>

    )
}

export default Resume
